/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultBasedAverage } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_gov_005: Question = {
  id: 'gov-005-montants-programmes',
  oldId: '5',
  title: 'Montants investis dans des programmes incitatifs',
  number: '1.5',
  frequency: 1,
  type: QuestionType.INDICATOR,
  description: ['Cet indicateur est mesuré selon les montants investis dans ces programmes, divisé par le nombre d\'habitants. Le nombre de points est ensuite déterminé en comparant le résultat à la moyenne des résultats des organismes municipaux du PEXBD.'],
  slots: [
    {
      type: SlotTypes.REPEATER,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data:number) => {
        if (data >= 100) return 4;
        if (data >= 75) return 3;
        if (data >= 50) return 2;
        if (data >= 25) return 1;
        return 0;
      },
      score: '0',
      maxScore: 4,
      repeaterFields: [
        {
          label: 'Nom du programme',
          slug: 'name',
          width: '30%',
        },
        {
          label: 'Personnes visées',
          slug: 'people',
          width: '30%',
        },
        {
          label: 'Montant accordé',
          slug: 'amount',
          width: '20%',
          type: 'number',
        },
        {
          label: 'Année',
          slug: 'year',
          width: '20%',
        },
      ],
      help: defaultBasedAverage,
      unit: SlotUnit.DOLLAR_PER_RESIDENT,
    },
  ],
};
const question_gov_005__v3: Question = {
  ...question_gov_005,
  title: 'Montants investis dans des programmes de financement ou des services sur le domaine privé',
};

export const question_gov_005_v2: Question = question_gov_005;
export const question_gov_005_v3: Question = question_gov_005__v3;
